<template>
    <div>
        <button v-if="!loading" type="button" @click="appendDataToModal" class="btn btn-sm btn-dark" data-toggle="modal">
            <span >{{ $t('label.description') }}</span>

        </button>
        <span v-else class="spinner-border spinner-border-sm"></span>

        <div id="description_modal"  class="modal fade rtl" role="dialog">
            <div class="modal-dialog">

                <!-- Modal content-->
                <div class="modal-content">
                    <div class="modal-header">
                        <div id="tx_title">
                        </div>
                        <div id="tx_log" class="ml-1">
                        </div>
                        <button type="button" class="close float-right mr-0" data-dismiss="modal">&times;</button>
                    </div>
                    <div id="data_sheet" class="modal-body mb-4">
                        <table id="factor_details" class="table table-hover"></table>
                        <table class="table table-hover">
                            <thead>
                            <tr>
                                <th class="table-info" colspan="2">{{ $t('label.transaction_detail') }}</th>
                            </tr>
                            </thead>
                            <tbody id="tr_details">
                            </tbody>
                        </table>
                        <table id="before_transaction" class="table table-hover">
                            <thead>
                            <tr>
                                <th class="table-info" colspan="2">{{ $t('label.before_transaction_status') }}</th>
                            </tr>
                            </thead>
                            <tbody id="initial_status">
                            </tbody>
                        </table>
                        <table id="init_date_tbl" class="table table-hover">
                        </table>
                        <table id="transaction_update_tbl" class="table table-hover">
                        </table>
                        <table id="after_transaction" class="table table-hover">
                            <thead>
                            <tr>
                                <th class="table-info" colspan="2">{{ $t('label.after_transaction_status') }}</th>
                            </tr>
                            </thead>
                            <tbody id="final_status">
                            </tbody>
                        </table>
                        <table id="api_tx_detail_tbl" class="table table-hover">
                        </table>
                    </div>
                </div>

            </div>
        </div>
    </div>
</template>

<script>
import Vue from 'vue'
import $ from 'jquery'
import { i18n } from '@/plugins/i18n'
import {transactionService} from "../../../common/api.service";
import toastr from "toastr";

export default Vue.extend({
    props: {
        row: {
            required: true,
        },
        index: {
            required: true,
        },
        datatable: {
            required: true,
        }
    },
    data() {
        return {
            data: {},
            loading: false,
            isError: false,
        }
    },

    methods: {
        des() {},
        dataArray() {
            let obj = this.row.description
            let obj_array = []
            let key, value
            for ([key, value] of Object.entries(obj)) {
                obj_array[key] = value
            }
            return obj_array
        },
        async appendDataToModal() {
            this.loading = true;
            await transactionService.fetchStarshopTransaction(this.query).then(({data}) => {
                this.data = data.data.data[0]
            }).catch(() => {
                this.isError = true;
                this.toastr.error(i18n.t('message.an_error_accord'))
            }).finally(() => {
                this.loading = false;
            })
            if (this.isError)
                return;
            $("#description_modal").modal('show')



            function simpleText(data, title){
                return '<tr><td style="width: 155px;">' + title + '</td>' +
                    '<td>' + data + '</td></tr>'
            }
            function currencyText(data, title){
                return '<tr><td style="width: 155px;">' + title + '</td>' +
                    '<td>' + data + ' ' + i18n.t('currency.rial') + '</td></tr>'
            }

            let tr_details = $('#tr_details').empty()
            let initial_status = $('#initial_status').empty()
            let init_date_tbl = $('#init_date_tbl').empty()
            let transaction_update_tbl = $('#transaction_update_tbl').empty()
            let final_status = $('#final_status').empty()
            let api_tx_detail_tbl = $('#api_tx_detail_tbl').empty()
            let tx_title = $('#tx_title').empty()
            let tx_log = $('#tx_log').empty()
            let factor_details = $('#factor_details').empty()

            if (this.data.transaction_type === 'شارژ کیف پول بانکداری باز' ||
                this.data.transaction_type === 'شارژ کیف پول پیامکی' ){
                document.getElementById('before_transaction').style.display = 'none'
                document.getElementById('after_transaction').style.display = 'none'
            }
            let ps_elements = '<h4 class="modal-title float-left p-0 m-0">' + i18n.t('label.transaction_description')+ ' ' + this.row.id + '</h4>'
            tx_title.append(ps_elements)

            if (this.data.log_url) {
                ps_elements = '<a href="' + this.data.log_url + '" target="_blank" class="btn btn-sm btn-clean btn-icon btn-icon-sm"><i class="fa fa-history"></i></a>'
                tx_log.append(ps_elements)
            }

            ps_elements = simpleText(this.data.tracking_code, i18n.t('label.tracking_code'))

            if (this.data.description.terminal_title) {
                ps_elements += simpleText(this.data.description.terminal_title, i18n.t('label.terminal_title'))
            }

            ps_elements += simpleText(this.data.port, i18n.t('label.psp'))

            if (this.data.description.pardakht_shakhsi_username) {
                ps_elements += simpleText(this.data.description.pardakht_shakhsi_username, i18n.t('label.pardakht_shakhsi_username'))
            }
            if (this.data.description.pardakht_shakhsi_payer_phone) {
                ps_elements += simpleText(this.data.description.pardakht_shakhsi_payer_phone, i18n.t('label.payer_phone'))
            }
            if (this.data.description.pardakht_shakhsi_payer_name) {
                ps_elements += simpleText(this.data.description.pardakht_shakhsi_payer_name, i18n.t('label.payer_name'))
            }
            if (this.data.description.pardakht_shakhsi_payer_email) {
                ps_elements += simpleText(this.data.description.pardakht_shakhsi_payer_email, i18n.t('label.payer_email'))
            }
            if (this.data.description.pardakht_shakhsi_payer_description) {
                ps_elements += simpleText(this.data.description.pardakht_shakhsi_payer_description, i18n.t('label.payer_description'))
            }
            if (this.data.description.api_order_id) {
                ps_elements += simpleText(this.data.description.api_order_id, i18n.t('label.order_id'))
            }
            if (this.data.description.api_payer_name) {
                ps_elements += simpleText(this.data.description.api_payer_name, i18n.t('label.payer_name'))
            }
            if (this.data.description.api_payer_phone) {
                ps_elements += simpleText(this.data.description.api_payer_phone, i18n.t('label.payer_phone'))
            }
            if (this.data.description.api_payer_mail) {
                ps_elements += simpleText(this.data.description.api_payer_mail, i18n.t('label.payer_email'))
            }
            if (this.data.description.api_description) {
                ps_elements += simpleText(this.data.description.api_description, i18n.t('label.description'))
            }
            if (this.data.description.sms_wallet_user_id && this.data.description.sms_wallet_user_name) {
                let id = this.data.description.sms_wallet_user_id;
                let name = this.data.description.sms_wallet_user_name.first_name + ' ' + this.data.description.sms_wallet_user_name.last_name;
                ps_elements += simpleText(`<a href="/users/${id}/details" target="_blank">${name}</a>`, i18n.t('label.payer_name'));
            }
            tr_details.append(ps_elements)

            ps_elements = ''
            if (this.data.description.initial_balance || this.data.description.initial_balance === 0) {
                if (this.data.transaction_type.includes('کیف')) {
                    ps_elements += currencyText(this.data.description.initial_balance, i18n.t('label.wallet_balance'));
                }
                if (this.data.transaction_type == i18n.t('transaction.types.collective_dedicated')) {
                    ps_elements += currencyText(this.data.description.initial_gateway_wage_wallet_balance, i18n.t('label.wallet_balance'));
                }
                else {
                    ps_elements += currencyText(this.data.description.initial_balance, i18n.t('label.initial_balance'));
                }
            }
            if (this.data.description.transaction_amount || this.data.description.transaction_amount === 0) {
                ps_elements += currencyText(this.data.description.transaction_amount, i18n.t('label.transaction_amount'))
            }
            if (this.data.description.transaction_wage || this.data.description.transaction_wage === 0) {
                ps_elements += currencyText(this.data.description.transaction_wage, i18n.t('label.transaction_wage'))
            }

            if (this.data.description.transaction_wage_bank || this.data.description.transaction_wage_bank === 0) {
                ps_elements += currencyText(this.data.description.transaction_wage_bank, i18n.t('label.transaction_wage_bank'))
            }

            if (this.data.description.transaction_real_amount || this.data.description.transaction_real_amount === 0) {
                ps_elements += currencyText(this.data.description.transaction_real_amount, i18n.t('label.transaction_real_amount'))
            }

            initial_status.append(ps_elements)

            if (this.data.description.transaction_type) {
                e = '<thead><tr>' +
                    '<th class="table-info" colspan="2">' + i18n.t('label.factor_details') + '</th>' +
                    '</tr></thead>' +
                    '<tbody id="factor_details_body"></tbody>'

                factor_details.append(e)

                let factor_details_body = $('#factor_details_body').empty()
                ps_elements = ''
                if (this.data.description.tracking_code) {
                    ps_elements += simpleText(this.data.description.tracking_code, i18n.t('label.factor_number'))
                }
                if (this.data.description.service_type) {
                    ps_elements += simpleText(this.data.description.service_type, i18n.t('label.service_type'))
                }
                if (this.data.description.customer_name) {
                    ps_elements += simpleText(this.data.description.customer_name, i18n.t('label.customer_name'))
                }
                if (this.data.description.phone) {
                    ps_elements += simpleText(this.data.description.phone, i18n.t('label.phone'))
                }
                if (this.data.description.order_id) {
                    ps_elements += simpleText(this.data.description.order_id, i18n.t('label.order_id'))
                }
                factor_details_body.append(ps_elements)
            }

            if (this.data.description.init_date) {
                let e = ''
                if (this.data.transaction_type === 'تسویه'){
                    e = '<thead><tr><th class="table-info" colspan="2">' + i18n.t('label.settlement_request') + '</th></tr></thead>' +
                        '<tbody><tr>' +
                        '<td style="width: 155px;">' + i18n.t('label.date') + '</td>' +
                        '<td>' + this.data.description.init_date + '</td>' +
                        '</tr></tbody>'
                } else {
                    e = '<thead><tr><th class="table-info" colspan="2">' + i18n.t('label.ipg_connection_request') + '</th></tr></thead>' +
                        '<tbody><tr>' +
                        '<td style="width: 155px;">' + i18n.t('label.date') + '</td>' +
                        '<td>' + this.data.description.init_date + '</td>' +
                        '</tr></tbody>'
                }

                init_date_tbl.append(e)
            }

            let e = '<thead><tr><th class="table-info" colspan="2">' + i18n.t('label.transaction_status_change') + '</th></tr></thead><tbody>'
            if (this.data.ref_id) {
                e += simpleText(this.data.ref_id, i18n.t('label.reference_id'))
            }
            if (this.data.description.bank_verification) {
                if (this.data.transaction_type !== 'تسویه') {
                    e += simpleText(this.data.description.bank_verification, i18n.t('label.bank_verification'))
                }
            }
            if (this.data.description.card_number) {
                e += '<tr><td style="width: 155px;">' + i18n.t('label.payer_card_number') + '</td>' +
                    '<td style="direction: ltr;">' + this.data.description.card_number + '</td></tr>'
            }
            if (this.data.description.payer_ip) {
                e += simpleText(this.data.description.payer_ip, i18n.t('label.payer_ip'))
            }
            if (this.data.description.result_message) {
                e += simpleText(this.data.description.result_message, i18n.t('label.result_message'))
            }
            if (this.data.description.transaction_update_date) {
                e += simpleText(this.data.description.transaction_update_date, i18n.t('label.date'))
            }
            if (this.data.description.transaction_status === 'transaction.succeeded') {
                e += '<tr class="table-success">' +
                    '<td style="width: 155px;">' + i18n.t('label.transaction_status') + '</td>' +
                    '<td>' + i18n.t('label.' + this.data.description.transaction_status) + '</td>' +
                    '</tr>'
            } else if (this.data.description.transaction_status === 'transaction.failed' ||
                this.data.description.transaction_status === 'transaction.unverified' ||
                this.data.description.transaction_status === 'transaction.reversed'
            ) {
                e += '<tr class="table-danger">' +
                    '<td style="width: 155px;">' + i18n.t('label.transaction_status') + '</td>' +
                    '<td>' + i18n.t('label.' + this.data.description.transaction_status) + '</td>' +
                    '</tr>'
            }
            e += '</tbody>'
            transaction_update_tbl.append(e)

            ps_elements = ''
            if (this.data.description.final_balance || this.data.description.final_balance === 0) {
                if (this.data.transaction_type.includes('کیف')) {
                    ps_elements += currencyText(this.data.description.final_balance, i18n.t('label.wallet_balance'));
                }
                if (this.data.transaction_type == i18n.t('transaction.types.collective_dedicated')) {
                    ps_elements += currencyText(this.data.description.final_gateway_wage_wallet_balance, i18n.t('label.wallet_balance'));
                }
                else {
                    ps_elements += currencyText(this.data.description.final_balance, i18n.t('label.final_balance'));
                }
            }
            if (this.data.description.added_amount || this.data.description.added_amount === 0) {
                if (this.data.transaction_type !== 'تسویه') {
                    ps_elements += currencyText(this.data.description.added_amount, i18n.t('label.added_amount'))
                } else {
                    ps_elements += currencyText(
                        (this.data.description.added_amount).slice(1, (this.data.description.added_amount).length),
                        i18n.t('label.deducted_amount')
                    )
                }
            }
            final_status.append(ps_elements)

            if (this.data.description.callback_url) {
                let e = '<thead><tr><th class="table-info" colspan="2">' + i18n.t('label.after_transaction_status') + '</th></tr></thead><tbody>'
                if (this.data.description.api_verify_date) {
                    e += simpleText(this.data.description.api_verify_date, i18n.t('label.api_verify_date'))
                }
                if (this.data.description.callback_url) {
                    e += simpleText(this.data.description.callback_url, i18n.t('label.callback_url'))
                }
                if (this.data.description.merchant_callback_response_code) {
                    e += simpleText(this.data.description.merchant_callback_response_code, i18n.t('label.merchant_callback_response_code'))
                }

                e += '</tbody>'
                api_tx_detail_tbl.append(e)
            }
        }
    },
    computed: {
        toastr() {
            toastr.options = {
                closeButton: true,
                positionClass: "toast-bottom-center",
                preventDuplicates: false,
                rtl: false
            }
            return toastr
        },
        query() {
            return `query[id]=${this.row.id}`;
        }
    }
})
</script>

<style>

</style>
